<template>
  <div class="banner-carousel">
    <!-- 标题 -->
    <span class="banner-carousel__title" @click="goDetail(currentItem)">{{ currentItem.title }}</span>

    <!-- 图片区域 -->
    <div class="banner-carousel__image-wrap" @click="goDetail(currentItem)">
      <img
        class="banner-carousel__image"
        referrerpolicy="no-referrer"
        :src="currentItem.coverImage"
        :alt="currentItem.title"
      />
      <!-- 底部渐变 + 指示器 -->
      <div class="banner-carousel__overlay">
        <span
          v-for="(item, idx) in carouselItems"
          :key="idx"
          class="banner-carousel__dot"
          :class="{ 'banner-carousel__dot--active': idx === activeIndex }"
          @click="goTo(idx)"
        ></span>
        <span class="banner-carousel__number">{{ padNumber }}</span>
      </div>
    </div>

    <!-- 来源 + 时间 -->
    <div class="banner-carousel__meta">
      <span class="banner-carousel__source">{{ currentItem.categoryName }}</span>
      <span class="banner-carousel__time">{{ currentItem.publishTime }}</span>
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'BannerCarousel',
  props: {
    items: {
      type: Array,
      required: true
    },
    interval: {
      type: Number,
      default: 4000 // 自动播放间隔，毫秒
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      carouselItems: [] // 轮播数据
    };
  },
  computed: {
    displayItems() {
      // 如果通过 prop 传入数据优先使用，否则使用 API 数据
      return this.items && this.items.length > 0 ? this.items : this.carouselItems;
    },
    currentItem() {
      return this.displayItems[this.activeIndex] || {};
    },
    padNumber() {
      return String(this.activeIndex + 1).padStart(2, '0');
    }
  },
  mounted() {
    this.loadCarouselData();
    if (this.displayItems.length === 0) {
      this.startAutoPlay();
    }
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    async loadCarouselData() {
      try {
        const res = await request.post('/api/index/getIndexRecommendInfo', {
          positionKey: 'index_carousel'
        });
        if (res.code === 200 && res.data && res.data.newsList && res.data.newsList.length > 0) {
          this.carouselItems = res.data.newsList.map(news => ({
            title: news.title,
            coverImage: news.coverImage,
            categoryName: news.categoryName,
            publishTime: news.publishTime,
            newsCode: news.newsCode
          }));
        }
      } catch (err) {
        console.error('获取轮播图数据失败:', err);
      }
    },
    goTo(idx) {
      this.activeIndex = idx;
      this.restartAutoPlay();
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.displayItems.length;
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.next();
      }, this.interval);
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    restartAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    },
    goDetail(item) {
      if (!item || !item.newsCode) return;
      this.$router.push(`/detail?newsCode=${item.newsCode}`);
    }
  }
};
</script>

<style scoped>
.banner-carousel {
  width: var(--content-width);
  margin-left: var(--space-6);
}

/* 标题 */
.banner-carousel__title {
  display: block;
  width: 100%;
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  font-weight: var(--weight-bold);
  text-align: left;
  line-height: 40px;
  margin: 20px 0 0;
  cursor: pointer;
}

/* 图片容器 */
.banner-carousel__image-wrap {
  position: relative;
  width: 100%;
  height: 425px;
  margin-top: 10px;
  overflow: hidden;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.banner-carousel__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 底部渐变覆盖层 */
.banner-carousel__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 87px;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
}

.banner-carousel__dot {
  display: block;
  width: 30px;
  height: var(--space-1);
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: var(--space-5);
  margin-right: 14px;
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.banner-carousel__dot:first-child {
  margin-left: 22px;
}

.banner-carousel__dot--active {
  width: 80px;
  background-color: rgba(255, 255, 255, 1);
}

.banner-carousel__number {
  color: var(--color-white);
  font-size: var(--font-md);
  font-family: var(--font-number);
  font-weight: var(--weight-bold);
  white-space: nowrap;
  line-height: 20px;
  margin-left: 4px;
}

/* 来源 + 时间 */
.banner-carousel__meta {
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  margin-top: 17px;
}

.banner-carousel__source,
.banner-carousel__time {
  color: var(--color-text-light);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 18px;
}

.banner-carousel__time {
  margin-left: 16px;
}
</style>
